<template>
    <v-container>
        <v-row>
            <v-col :cols="12">
                <v-textarea readonly hide-details :label="$t('Beschreibung')" :value="emptyDescription" no-resize :rows="3" outlined />
            </v-col>
            <v-col :cols="6">
                <v-text-field readonly hide-details :label="$t('Minimale Punktzahl')" :value="value.minScore" />
            </v-col>
            <v-col :cols="6">
                <v-text-field readonly hide-details :label="$t('Maximale Punktzahl')" :value="value.score" />
            </v-col>
        </v-row>
        <v-row>
            <v-col :cols="6">
                <v-btn block color="secondary" @click.stop="switchToTeacherView" :disabled="showTeacherView">
                    <span>{{ $t('VORGABEN') }}</span>
                </v-btn>
            </v-col>
            <v-col :cols="6">
                <v-btn block color="secondary" @click.stop="switchToUserView" :disabled="showUserView">
                    <span> {{ $t('EIGENMANAGEMENT') }}</span>
                </v-btn>
            </v-col>
        </v-row>
        <v-expand-transition mode="out-in">
            <v-row v-if="showTeacherView">
                <v-col :cols="6">
                    <v-text-field readonly hide-details :label="$t('Startdatum')" :value="value.startDate" />
                </v-col>
                <v-col :cols="6">
                    <v-text-field readonly hide-details :label="$t('Enddatum')" :value="value.endDate" />
                </v-col>
                <v-col :cols="6">
                    <v-text-field
                        readonly
                        hide-details
                        :label="$t('Arbeitsaufwand')"
                        :value="`${convertMinutes} ${$t('à')} ${timeScaleInMinutes} ${$t('Minuten')}`"
                    />
                </v-col>
                <v-col :cols="6">
                    <v-text-field readonly hide-details :label="$t('Dauer')" :value="`${hiddenDurationInDays} ${computedDays}`" />
                </v-col>
            </v-row>
        </v-expand-transition>
        <v-expand-transition>
            <v-row v-if="showUserView">
                <v-col :cols="6">
                    <v-text-field readonly hide-details :label="$t('Start')" :value="`${emptyStartDate} / ${emptyStartTime.split(':00')[0]}`" />
                </v-col>
                <v-col :cols="6">
                    <v-text-field readonly hide-details :label="$t('Ende')" :value="`${emptyEndDate} / ${emptyEndTime.split(':00')[0]}`" />
                </v-col>
                <v-col :col="12">
                    <v-textarea readonly hide-details outlined :label="$t('Notizen')" :value="emptyNotes" no-resize :rows="3" />
                </v-col>
                <v-col :cols="12">
                    <UpdateMyCourse :items="this.getScheduling" :course="this.value" :courseType="'course'" />
                </v-col>
            </v-row>
        </v-expand-transition>
    </v-container>
    <!-- <v-flex class="pa-0">
        <v-layout column mt-2>
            <v-flex py-0>
                <span class="text-caption primary--text">{{ $t('Beschreibung') }}</span>
            </v-flex>
            <v-flex pt-0>
                <span
                    v-text="emptyDescription"
                    style="white-space: pre-wrap"
                    :class="{
                        'body-1': true,
                        limit: this.selectable
                    }"
                >
                </span>
            </v-flex>
        </v-layout>
        <v-divider class="my-2" v-if="computedShowScore"></v-divider>
        <v-layout v-if="computedShowScore">
            <v-flex xs6>
                <v-layout column>
                    <v-flex pb-0>
                        <span class="text-caption primary--text">{{ $t('Minimale Punktzahl') }}</span>
                    </v-flex>
                    <v-flex pt-0>
                        <span class="text-caption font-weight-bold">{{ value.minScore }}</span>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs6>
                <v-layout column>
                    <v-flex pb-0>
                        <span class="text-caption primary--text">{{ $t('Maximale Punktzahl') }}</span>
                    </v-flex>
                    <v-flex pt-0>
                        <span class="text-caption font-weight-bold">{{ value.score }}</span>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-divider class="my-2"></v-divider>
        <v-layout wrap py-2>
            <v-flex xs12 sm6 md6 class="text-center">
                <v-btn v-bind="teacherView" block color="secondary" @click.stop="switchToTeacherView">
                    <span>{{ $t('VORGABEN') }}</span>
                </v-btn>
            </v-flex>
            <v-flex xs12 sm6 md6 class="text-center">
                <v-btn v-bind="userView" block color="secondary" @click.stop="switchToUserView">
                    <span> {{ $t('EIGENMANAGEMENT') }}</span>
                </v-btn>
            </v-flex>
        </v-layout>
        <div v-show="showTeacherView">
            <v-divider class="my-2"></v-divider>
            <v-layout mt-2>
                <v-flex xs6>
                    <v-layout column>
                        <v-flex pb-0>
                            <span class="text-caption primary--text">{{ $t('Startdatum') }}</span>
                        </v-flex>
                        <v-flex pt-0>
                            <span class="text-caption font-weight-bold">{{ value.startDate }}</span>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs6>
                    <v-layout column>
                        <v-flex pb-0>
                            <span class="text-caption primary--text">{{ $t('Enddatum') }}</span>
                        </v-flex>
                        <v-flex pt-0>
                            <span class="text-caption font-weight-bold">{{ value.endDate }}</span>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-divider class="my-2"></v-divider>
            <v-layout>
                <v-flex xs6>
                    <v-layout column>
                        <v-flex pb-0>
                            <span class="text-caption primary--text">{{ $t('Arbeitsaufwand') }}</span>
                        </v-flex>
                        <v-flex pt-0>
                            <span class="text-caption font-weight-bold">{{ `${convertMinutes} ${$t('à')} ${timeScaleInMinutes} ${$t('Minuten')}` }}</span>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs6>
                    <v-layout column>
                        <v-flex pb-0>
                            <span class="text-caption primary--text">{{ $t('Dauer') }}</span>
                        </v-flex>
                        <v-flex pt-0>
                            <span class="text-caption font-weight-bold">{{ ` ${hiddenDurationInDays} ${computedDays}` }}</span>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </div>
        <div v-show="showUserView">
            <v-divider class="my-2"></v-divider>
            <v-layout mt-2>
                <v-flex xs6>
                    <v-layout column>
                        <v-flex pb-0>
                            <span class="text-caption primary--text">{{ $t('Start') }}</span>
                        </v-flex>
                        <v-flex py-0>
                            <span class="text-caption font-weight-bold">{{ emptyStartDate + ' / ' + emptyStartTime.split(':00')[0] }}</span>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs6>
                    <v-layout column>
                        <v-flex pb-0>
                            <span class="text-caption primary--text">{{ $t('Ende') }}</span>
                        </v-flex>
                        <v-flex pt-0>
                            <span class="text-caption font-weight-bold">{{ emptyEndDate + ' / ' + emptyEndTime.split(':00')[0] }}</span>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-divider class="my-2"></v-divider>
            <v-layout column>
                <v-flex pb-0>
                    <span class="text-caption primary--text">{{ $t('Notizen') }}</span>
                </v-flex>
                <v-flex pt-0>
                    <span
                        v-text="emptyNotes"
                        style="white-space: pre-wrap"
                        :class="{
                            'body-1': true,
                            limit: this.selectable
                        }"
                    ></span>
                </v-flex>
            </v-layout>
            <v-layout wrap justify-end align-center class="py-0">
                <v-flex v-if="!$vuetify.breakpoint.xs" shrink class="py-0">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn large icon class="editButton" color="amber darken-2" v-on="on" @click.stop="updateScheduling">
                                <v-icon color="white">edit</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('Bearbeiten') }}</span>
                    </v-tooltip>
                </v-flex>
                <v-flex v-else shrink xs12 mt-2>
                    <v-layout column justify-center>
                        <v-flex>
                            <v-btn class="ml-0" style="width: 100%" color="amber darken-2" @click.stop="updateScheduling">
                                <v-icon color="white">edit</v-icon>
                                <span class="pl-2" style="color: white">{{ $t('Bearbeiten') }}</span>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </div>
        <UpdateMyCourse
            v-model="showUserUpdate"
            :items="this.getScheduling"
            :course="this.value"
            :userPreference="this.userPreference"
            :courseType="'learningGoal'"
        ></UpdateMyCourse>
    </v-flex> -->
</template>
<script>
import UpdateMyCourse from '../../UpdateMyCourse';
import CourseMixin from '../../Mixins/CourseMixin';
export default {
    name: 'my-topic-info',
    components: { UpdateMyCourse },
    mixins: [CourseMixin],
    data: () => ({
        teacherView: '',
        userView: { outline: true },
        showTeacherView: true,
        showUserView: false,
        showUserUpdate: false,
        modalActive: 0,
        getScheduling: {},
        userPreference: false,
        startDate: '',
        startTime: '',
        endDate: '',
        endTime: ''
    }),
    watch: {
        showUserUpdate(value) {
            if (!value) {
                this.GET_LEARNING_GOAL_SCHEDULING(this.value).then((response) => (this.getScheduling = response));
            }
        },
        showMoreInfo(value) {
            if (value) {
                this.GET_LEARNING_GOAL_SCHEDULING(this.value).then((response) => (this.getScheduling = response));
                this.GET_COURSE_USER_PREFERENCES()
                    .then((response) => (this.userPreference = response.prefersUserScheduling))
                    .then((response) => this.isUserPreference(response));
            }
        },
        getScheduling(value) {
            if (value) {
                if (this.getScheduling.startDate !== null) {
                    this.startDate = this.getScheduling.startDate.split(' ')[0];
                    this.startTime = this.getScheduling.startDate.split(' ')[1];
                }
                if (this.getScheduling.endDate !== null) {
                    this.endDate = this.getScheduling.endDate.split(' ')[0];
                    this.endTime = this.getScheduling.endDate.split(' ')[1];
                }
            }
        }
    },
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
        selectable: {
            type: Boolean,
            default: false
        },
        durationInDays: {
            type: Number,
            default: 0
        },
        isMyCourse: {
            type: Boolean,
            default: false
        },
        timeScaleInMinutes: {
            type: Number,
            default: 60
        },
        showMoreInfo: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        computedShowScore() {
            if (!this.getSelectedAttendeeCourse.useEvaluation) {
                return false;
            } else if (this.value.minScore === 0) {
                return false;
            }
            return true;
        },
        hiddenDurationInDays() {
            if (this.isMyCourse && this.value.hideDurationInDays) {
                return '-';
            }
            return this.value.durationInDays;
        },
        computedDays() {
            if (this.value.durationInDays === 1) {
                return this.$t('Tag');
            }
            return this.$t('Tage');
        },
        emptyDescription() {
            if (this.value.description.length === 0) {
                return '-';
            }
            return this.value.description;
        },
        emptyNotes() {
            if (this.getScheduling.notes === null) {
                return '-';
            }
            return this.getScheduling.notes;
        },
        emptyStartDate() {
            if (this.getScheduling.startDate === null || this.getScheduling.startDate === '') {
                return '-';
            }
            return this.startDate;
        },
        emptyStartTime() {
            if (this.getScheduling.startDate === null) {
                return '-';
            }
            return this.startTime;
        },
        emptyEndDate() {
            if (this.getScheduling.endDate === null) {
                return '-';
            }
            return this.endDate;
        },
        emptyEndTime() {
            if (this.getScheduling.endDate === null) {
                return '-';
            }
            return this.endTime;
        },
        convertMinutes() {
            if (this.isMyCourse && this.value.hideEstimatedWorkTimeInMinutes) {
                return '-';
            }
            const timeUnitMinutes = this.value.estimatedWorkTimeInMinutes % this.timeScaleInMinutes;
            const timeUnit = this.value.estimatedWorkTimeInMinutes / this.timeScaleInMinutes;

            if (timeUnitMinutes.toString().length === 1) {
                return `${timeUnit.toString().split('.')[0]}:${'0' + timeUnitMinutes.toString()} Einheiten`;
            }
            return `${timeUnit.toString().split('.')[0]}:${timeUnitMinutes.toString()} Einheiten`;
        }
    },
    methods: {
        switchToTeacherView() {
            this.teacherView = { outline: false };
            this.userView = { outline: true };
            this.showTeacherView = true;
            this.showUserView = false;
        },
        switchToUserView() {
            this.userView = { outline: false };
            this.teacherView = { outline: true };
            this.showTeacherView = false;
            this.showUserView = true;
        },
        isUserPreference(value) {
            if (value) {
                this.switchToUserView();
            } else {
                this.switchToTeacherView();
            }
        },
        updateScheduling() {
            this.showUserUpdate = true;
        }
    }
};
</script>
<style scoped>
.limit {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
}
</style>
